<div class="wrapper p-2">
    <ngx-spinner bdColor="#fbfbfb" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="false">
        <h6 class="mt-2">Processando...</h6>
    </ngx-spinner>
</div>
